<template>
<section>
    <div class="container">
         <CommonBreadcrumb class="my-3"/>
    </div>
    <header class="banner">
        <picture>
            <source media="(min-width: 768px)" width="3840" height="1100" type="image/webp"
                srcset="~/assets/friendly-services/banner.webp">
            <source media="(min-width: 768px)" width="3840" height="1100" type="image/jpeg"
                srcset="~/assets/friendly-services/banner.jpg">

            <source media="(max-width: 991x)" width="750" height="400" type="image/webp"
                srcset="~/assets/friendly-services/banner_mob.webp">
            <source media="(max-width: 991px)" width="750" height="400" type="image/jpeg"
                srcset="~/assets/friendly-services/banner_mob.jpg">
            <img width="3840" height="1100" type="image/jpeg" src="~/assets/friendly-services/banner.jpg"
                alt="The Friendly Diamonds Difference banner">
        </picture>

        <div class="banner_title">
            <h1 class="font-active ">The ‘Friendly’ <span>Service</span></h1>

            <p class="mb-0">FOR A FRIENDLIER <span>EXPERIENCE</span></p>
        </div>
    </header>
    <main class=" container main vertical-spacing">

        <div
            class="d-flex justify-content-between flex-column flex-md-row align-items-center w-100   counter_container">

            <div class="counter border-right ">
                <div class="d-flex align-items-center gap-1">

                    <h4 id="countup1" class="countup font-active text-uppercase title">20000</h4>
                    <span class="plus">+</span>
                </div>
                <p class="countup-text mb-md-0">SATISFIED CUSTOMERS</p>
            </div>
            <div class="counter border-right ">
                <div class="d-flex align-items-center gap-1">
                    <h4 id="countup2" class="countup font-active text-uppercase title">400000</h4>
                    <span class="plus">+</span>
                </div>
                <p class="countup-text mb-md-0">CERTIFIED DIAMONDS</p>
            </div>
            <div class="counter">
                <div class="d-flex align-items-center gap-1">
                    <h4 id="countup3" class="countup font-active text-uppercase title">1000</h4>
                    <span class="plus">+</span>
                </div>
                <p class="countup-text mb-md-0">EXQUISITE DESIGNS</p>
            </div>
        </div>

        <section class="friendly-experience  ">
            <h2 class="vertical-spacing text-center font-active title fw-medium">Here’s How We Bring You A Friendly
                Experience</h2>
            <!-- The image alternate block -->
            <div class="text-center text-md-start">
                <!-- IMG 1 -->
                <div class="row flip align-items-center mb-60">
                    <div class="col-12 col-md-6">
                        <div class="mt-3">
                            <h4 class="font-active title">Certified Diamond Inventory & Visuals</h4>

                            <p class="mb-0 row-content">Our inventory boasts over 100,000 certified lab diamonds
                                available in a
                                variety of shapes and sizes. We offer high-definition videos and super-zoom images of
                                the actual diamonds, allowing you to examine any inclusions or blemishes and showing
                                them as realistically as possible. Our website’s diamond filtration system allows you to
                                find the perfect diamond for every budget. Our goal is to make your diamond shopping
                                experience as transparent and informative as possible, ensuring you make a confident,
                                informed choice.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  ">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="660" type="image/webp"
                                    srcset="~/assets/friendly-services/certified_diamond.webp">

                                <img width="1230" height="660" type="image/jpeg" class="radious_eight"
                                    src="~/assets/friendly-services/certified_diamond.jpg" alt="certified_diamond">
                            </picture>
                        </div>
                    </div>
                </div>

                <!-- IMG 2 -->
                <div class="row align-items-center mb-60">
                    <div class="col-12 col-md-6  ">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="1200" type="image/webp"
                                    srcset="~/assets/friendly-services/jewellery_options.webp">
                                <img width="1230" height="1200" type="image/jpeg" class="radious_eight"
                                    src="~/assets/friendly-services/jewellery_options.jpg" alt="jewellery_options">
                            </picture>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  ">
                        <div class="mt-3">
                            <h4 class="font-active title">Versatile Jewelry Options - For Every Need</h4>

                            <p class="mb-0 row-content">With over 10+ categories and 300+ designs, we offer jewelry to
                                suit every
                                occasion, whether it's everyday wear, a wedding, or a cocktail party with options to
                                personalize & customize it down to every detail. With our Virtual Try On feature you can
                                view every piece on your hand in different metal colors and carat weights. You can
                                choose from our ready-to-ship collection or customize your jewelry exactly as you desire
                                for something truly unique.
                            </p>
                        </div>
                    </div>

                </div>

                <!-- IMG 3 -->
                <div class="row flip align-items-center mb-60">
                    <div class="col-12 col-md-6  ">
                        <div class="mt-3">
                            <h4 class="font-active title">Ultimate User Experience - just like your next door jeweler!
                            </h4>

                            <p class="mb-0 row-content">Our ultimate goal with our website is to provide you with an
                                exceptional
                                user experience, making you feel as though we are your local jewelers. Our platform is
                                customer-centric, intuitive and easy to use, ensuring that you never feel lost and enjoy
                                a seamless experience. It offers a personal touch, with features to opt for a
                                gemologist’s guidance at every step of the way ensuring you feel well-supported.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="660" type="image/webp"
                                    srcset="~/assets/friendly-services/user_experience.webp">

                                <img width="1230" height="660" type="image/jpeg"
                                    src="~/assets/friendly-services/user_experience.jpg" alt="user_experience">
                            </picture>
                        </div>
                    </div>
                </div>

                <!-- IMG 4 -->
                <div class="row align-items-center mb-60">
                    <div class="col-12 col-md-6  ">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="1200" type="image/webp"
                                    srcset="~/assets/friendly-services/friendly_humans.webp">
                                <img width="1230" height="1200" type="image/jpeg"
                                    src="~/assets/friendly-services/friendly_humans.jpg" alt="friendly_humans">
                            </picture>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  ">
                        <div class="mt-3">
                            <h4 class="font-active title">A bunch of <span class="fst-italic">friendly</span> humans -
                                available at your
                                service</h4>

                            <p class="mb-0 row-content">We dont let bots do the talking! Our customer service team is a
                                bunch of
                                friendly humans who are certified jewelry specialists, GIA gemologists, and diamond
                                experts. They aren't here to sell you diamonds—they're here to help you make an informed
                                decision and ensure your experience is nothing short of perfect. They are available
                                across all timezones and you can reach out to them at your own comfort and flexibility
                                via chat, call or email. You can also book a virtual appointment for personalized
                                attention or a diamond viewing appointment at our New York office.
                            </p>
                        </div>
                    </div>

                </div>

                <!-- IMG 5 -->
                <div class="row flip align-items-center mb-60">
                    <div class="col-12 col-md-6  ">
                        <div class="mt-3">
                            <h4 class="font-active title">More Than a Transaction - Your Satisfaction Guaranteed</h4>

                            <p class="mb-0 row-content">Your purchase isn't just a transaction to us—our job isn't done
                                until you're
                                100% satisfied. We accept payments via credit & debit cards, bank transfer and PayPal
                                and also offer flexible financing options like After-Pay, Affirm & Split it. We offer
                                comprehensive after sales services like a no-questions-asked 30-day return policy,
                                lifetime warranty, free resizing and a diamond trade-in service. Learn more about our
                                services & values. Your confidence in us is our greatest reward.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  ">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="660" type="image/webp"
                                    srcset="~/assets/friendly-services/transaction.webp">

                                <img width="1230" height="660" type="image/jpeg"
                                    src="~/assets/friendly-services/transaction.jpg" alt="transaction">
                            </picture>
                        </div>
                    </div>
                </div>

                <!-- IMG 6 -->
                <div class="row align-items-center ">
                    <div class="col-12 col-md-6  ">
                        <div class="img_container">
                            <picture>
                                <source width="1230" height="1200" type="image/webp"
                                    srcset="~/assets/friendly-services/precious_moments.webp">
                                <img width="1230" height="1200" type="image/jpeg"
                                    src="~/assets/friendly-services/precious_moments.jpg" alt="precious_moments">
                            </picture>
                        </div>
                    </div>
                    <div class="col-12 col-md-6  ">
                        <div class="mt-3">
                            <h4 class="font-active title">Protecting Your Precious Moments - Your Security, Our Priority
                            </h4>

                            <p class="mb-0 row-content">Your security and peace of mind are paramount to us. We
                                maintain complete
                                confidentiality of all the information you share with us and our secure payment gateways
                                guarantee your financial safety. We source certified diamonds only from the most trusted
                                vendors, and our jewelry comes with IGI certifications of authenticity. We take full
                                responsibility for every purchase, offering insured shipping to protect your investment.
                                Your trust is the foundation of our relationship, and we are committed to maintaining it
                                at every step.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section class="reviews_container ">
            <h2 class="vertical-spacing text-center title font-active">And if you still don’t believe all of it? Hear it
                from our
                customers!</h2>
            <div class="mb-60 ">
                <TestimonialsRatingSlider />
            </div>
        </section>
        <section class="ratings_container ">
            <div class="container" v-if="$country.trustpilot">
                <HomeTrustpilotReview />
            </div>
        </section>

        <div class="bottom_link">
            <p class="vertical-spacing text-center fw-bold">Join us on this journey and experience the Friendly Diamonds
                Difference today!</p>

            <NuxtLink :to="localePath('')" class="end_button d-block w-100 radious_eight">
                <span>Our Diamonds Are <s>The Best</s> Truly Friendly!</span>
            </NuxtLink>

        </div>
    </main>
</section>
</template>

<script setup>
import { CountUp } from 'countup.js';

onMounted(()=>{
     new CountUp("countup1", 20000,{ enableScrollSpy: true,scrollSpyOnce:true });
     new CountUp("countup2", 400000,{ enableScrollSpy: true ,scrollSpyOnce:true});
     new CountUp("countup3", 1000,{ enableScrollSpy: true ,scrollSpyOnce:true});
})

useFetchMeta( useNuxtApp(), useRuntimeConfig() );
const { $country } = useNuxtApp();



const localePath = useLocalePath();
</script>

<style scoped>
/* Common */

img {
    width: 100%;
    height: auto;
}

.img_container img {

}

.vertical-spacing {
    margin-top: 30px;
    margin-bottom: 30px
}

.mb-60 {
    margin-bottom: 30px
}


.fst-italic {
    font-style: italic;
    color: #668b84;
}

/* banner */
.banner {
    position: relative;
}

.banner_title {
    position: absolute;
    top: 45%;
    left: 10%;
    transform: translate(-10%, -45%);
}

.banner_title h1 {
    font-size: 24px;
    margin-bottom: 4px;
    color: #d59066;


}

.banner_title span {
    color: #405955;
}

.banner_title p {
    font-size: 12px;
    color: #d59066;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-weight: medium;


}

.banner_title p span {
    font-weight: 600;
    color: #405955;
    font-weight: bold;
}


/* counter */
.counter {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.countup,
.plus {
    color: #353535 !important;
    font-weight: bold;
    font-size: 28px;
}

.countup-text {

    font-size: 14px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #606060;
    font-weight: 400;
}


/* friendly-experience */
.title {
    font-size: 24px;
    line-height: 32px;
    color: #212529;
}

.friendly-experience .row-content {
    font-size: 14px;
    line-height: 22px;
    color: #606060;
}

/* reviews_container */
.reviews_container h2 {
    color: #405955;
    font-style: italic;
    font-weight: normal !important;
    line-height: 32px;
}

.bottom_link p {
    font-size: 14px;
    line-height: 22px;
}


.end_button {
    background-color: #405955;
    padding: 15px;
  
    text-align: center;
}

.end_button span {
    font-size: 16px;
    font-style: italic;
    color: #ffffff;
}


@media(max-width: 767px) {

    .flip {
        flex-direction: column-reverse;
    }

    .end_button span {
        font-size: 14px;
    }


}

/* desktop designs */
@media(min-width:540px) {
    .banner_title h1 {
        font-size: 42px;
        margin-bottom: 15px;
    }

    .banner_title p {
        font-size: 16px;
        letter-spacing: 4px;
    }
}

@media(min-width:768px) {

    .countup,
    .plus {
        font-size: 32px;
    }

    .countup-text {
        font-size: 16px;
        letter-spacing: 2px;
    }

    .border-right {
        border-right: 1px solid #c4c4c4;
    }

    .title {
        /* desktop */
        font-size: 26px;
        line-height: 38px;
    }

    .friendly-experience .row-content {
        font-size: 16px;
        line-height: 24px;
        color: #606060;
    }

    .img_container img {
        border-radius: 8px;
    }


    .bottom_link p {
        font-size: 16px;
    }

}

/* desktop designs */
@media(min-width:992px) {
    .banner_title h1 {
        font-size: 60px;
    }

    .banner_title p {
        font-size: 24px;
        line-height: 24px;
    }

    .vertical-spacing {
        margin-top: 60px;
        margin-bottom: 60px
    }

    .mb-60 {
        margin-bottom: 60px
    }

    .title {
        /* desktop */
        font-size: 32px;
        line-height: 42px;
    }

}
</style>
